module.exports = __webpack_public_path__ + "img/nature-67.2e8b2a31.jpg";